/*
 * @Author: your name
 * @Date: 2020-06-18 10:46:41
 * @LastEditTime: 2020-06-18 10:49:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /新云网运营管理系统/src/api/user.js
 */
import request from '@/utils/request';
import ENVIRONMENT from '@/utils/environment';

/**
 *   获取用户信息
 * @method getUserInfo
 * @return { request } axsio请求封装
 */
export function getUserInfoDetail() {
  return request({
    url: `/v1/portal/web/user/info`,
    method: 'get'
  });
}
/**
 *   上传头像地址
 */
export function uploadProfilePhotoUrl() {
  return `${ENVIRONMENT.BASE_API}/op/file/upload`;
}

/**
 *   修改密码
 * @param {*} data
 */
export function editPassword(data) {
  return request({
    url: `/v1/auth/portal/password/reset`,
    method: 'post',
    data: data
  });
}

/**
 *   修改头像
 * @param {*} data
 */
export function editProfilePhoto(accountId, profilePhotoPath) {
  return request({
    url: `/op/member/modifyProfile`,
    method: 'post',
    data: { accountId, flag: '6', profilePhotoPath }
  });
}
// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 *   获取门户详细信息
 */
export function getportalInfo() {
  return request({
    url: `/v1/portal/web/whitelist/info`,
    method: 'get'
  });
}
/**
 *   获取门户模块列表
 */
export function getportalModules() {
  return request({
    url: `/v1/portal/web/whitelist/modules`,
    method: 'get'
  });
}
/**
 *   获取门户广告
 */
export function getEduAdvertisingPics(data) {
  return request({
    url: `/whitelist/front/eduAdvertisings/allList`,
    method: 'get',
    params: data
  });
}
/**
 *   获取门户导航栏列表
 */
export function getportalNav() {
  return request({
    url: `/v1/portal/web/whitelist/navigation`,
    method: 'get'
  });
}
/**
 *   获取后台管理地址
 */
export function getportalManagementUrl() {
  return request({
    url: `/v1/portal/web/management`,
    method: 'get'
  });
}
/**
 *   获取oa消息
 */
export function getOaMessage() {
  return request({
    url: `/v1/portal/web/oa/message`,
    method: 'get'
  });
}

/**
 *   获取精品推荐用户身份
 */
export function checkLoginUser(typeCode) {
  return request({
    url: `/v1/unity/web/checkLoginUser/${typeCode}`,
    method: 'get'
  });
}
